
export default {
  props: ["r"],
};
